<script>
import { mapGetters } from 'vuex'
import { brightness } from '@/utils/color'
export default {
    name: 'Engage',

    computed:
    {
        ...mapGetters(['page']),
        themeClass()
        {
            if (this.page && this.page.layouts && this.page.layouts.length)
            {
                return `style-${this.page.layouts[0].internal_name}`
            }
            return 'style-default'
        },

        themeColor()
        {
            return this.page ? this.page.color : null
        },
    },

    watch:
    {
        themeColor: {
            immediate: true,
            handler: 'setColor' 
        }
    },

    methods:
    {
        loadingStart()
        {
            document.getElementyByTagName('body')[0].classList.remove('loaded')
        },

        loadingEnd()
        {
            document.getElementyByTagName('body')[0].classList.add('loaded')
        },

        setColor()
        {
            const el = this.$refs.mainElement
            if (el && this.themeColor)
            {
                el.style.setProperty('--color', this.themeColor)
                el.style.setProperty('--button-color', brightness(this.themeColor) > 130 ? '#000' : '#fff')
            }
        }
    },

}
</script>

<template>
    <div id="app">
        <trackers></trackers>
        <main :class="themeClass" ref="mainElement">
            <router-view>

            </router-view>
        </main>
    </div>
</template>



// WEBPACK FOOTER //
// src/App.vue